import * as actionTypes from 'constants/ActionTypes';

const initState = {

};

const sender = (state = initState, action) => {
    switch (action.type) {
        case actionTypes.GET_SEND_EMAIL.REQUEST:
            return {
                ...state,
            };
        case actionTypes.GET_SEND_EMAIL.SUCCESS:
            return {
                ...state,
                ...action.data,
            };
        case actionTypes.GET_SEND_EMAIL.FAILURE:
            return {
                ...state,
            };

        default:
            return state;
    }
};

export default sender;



// WEBPACK FOOTER //
// ./app/reducers/sender/sender.js